export const mapStatusToText: { [key: string]: string } = {
  A: 'Active',
  R: 'Retired',
  D: 'Deactivated',
  RS: 'Resolved',
}
